define('C3.ShoppingExtensions.Carousel.CollectionUpdated',
  [
  'C3.ShoppingExtensions.Carousel.Model',
  'Utils',
  'SCCollection',
  'SCModel',
  'underscore'
  ],
  function (NewArrivalsModel, Utils,SCCollectionModule,SCModelModule,_) {
    'use strict';

     var SCCollection = SCCollectionModule.SCCollection;
     var SCModel = SCModelModule.SCModel;


     function CarouselCollectionUpdated(models, options) {
      SCCollection.call(this, models, options);

      this.model = SCModel;

      this.customFilters = options && options.filters;


      this.url = function url () {
        return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "services/Carousel.Service.ss"
                )
              )
      }

       this.parse = function parse(response) {
        console.log(response)
        this.totalRecordsFound = response.resp.totalResultsCount;
        this.recordsPerPage = 50;
        //
        var carouselData = response.resp.mostPopularData;
       // console.log(carouselData)
        return carouselData.items;
      }

      this.update = function update(options){
         const data = {
              filter: options.filter,
              pageNumber: options.page || 1,
              resultsPerPage: options.resultsPerPage || 50,
              keyword : options.keyword
          };

         // console.log(data)
          
          this.fetch({
              data: data,
              reset: true,
              killerId: options.killerId
          });
      }
    }

    CarouselCollectionUpdated.prototype = Object.create(SCCollection.prototype);
    CarouselCollectionUpdated.prototype.constructor = CarouselCollectionUpdated;

    return CarouselCollectionUpdated;
    
  }
);
